import history from 'config/history';

export const checkIfActive = urls => {
  const { pathname } = history.location;

  return urls.includes(pathname);
};
